import { Component, computed, inject, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { NavigationStore, Scheme, UserStore } from '@workspace/ng-data-access';
import { Media, Theming } from '../../providers';
import {
  SidebarNavigationAuxiliaryActions,
  StackedLayoutAudienceOption,
  StackedLayoutSimple,
} from '../builderkit';
import { AUTH_SPLIT_LAYOUT_CONFIG, AuthSplitLayoutConfig } from './auth-split-layout';
import { AuraBrandBannerComponent } from './banner/brand-banner/brand-banner.component';

export type { StackedLayoutAudienceOption } from '../builderkit';

@Component({
  selector: 'aura-layout',
  imports: [
    MatSidenavModule,
    MatIconModule,
    SidebarNavigationAuxiliaryActions,
    StackedLayoutSimple,
    AuraBrandBannerComponent,
  ],
  templateUrl: './layout.component.html',
})
export class LayoutComponent {
  // Services / stores
  protected theming = inject(Theming);
  private media = inject(Media);
  private navigationStore = inject(NavigationStore);
  private userStore = inject(UserStore);
  private authConfig = inject<AuthSplitLayoutConfig | null>(AUTH_SPLIT_LAYOUT_CONFIG, { optional: true });

  // Inputs
  readonly appName = input<string, string | undefined | null>(this.authConfig?.appName ?? '', {
    transform: (v) => v || this.authConfig?.appName || '',
  });
  readonly logoUrl = input<string, string | undefined | null>(
    this.authConfig?.logoUrl ?? '/images/logo/logo.svg',
    {
      transform: (v) => v || this.authConfig?.logoUrl || '/images/logo/logo.svg',
    },
  );
  readonly homeUrl = input<string, string | undefined | null>('/', {
    transform: (v) => v || '/',
  });
  readonly appBadge = input<string | null, string | undefined | null>(null, {
    transform: (v) => v ?? null,
  });
  readonly audienceOptions = input<
    StackedLayoutAudienceOption[],
    StackedLayoutAudienceOption[] | undefined | null
  >([], {
    transform: (v) => v ?? [],
  });

  // State (directly consume store signals)
  readonly user = this.userStore.currentUser;
  readonly navigationItems = this.navigationStore.items;
  readonly layout = this.navigationStore.layout;

  // Derived state
  protected isMobile = computed(() => this.media.match('(max-width: 767px)')());

  // Actions
  updateScheme(scheme: Scheme) {
    this.theming.scheme.set(scheme);
  }
}
